import { gql, useMutation } from "@apollo/client";
import React, { useRef, useState } from "react";
import { MenuComponent, MenuProps } from "../../../components/MenuComponent";
import { Toast } from "../../../hooks/toast";
import { OrderStatus } from "./OrderStatus";
import { PrintItem } from "./print/PrintItem";
import { Modal } from "react-bootstrap";

//@ts-ignore
import Barcode from "react-barcode";
import { TestJson } from "../../../lib/TestJson";
import { Link } from "react-router-dom";
import { confirmService } from "src/hooks/confirmHook";
import HeaderTable from "src/components/table/HeaderTable";
import { Pagination } from "src/components/pagination";
import { Graph } from "src/generated/graph";

const CHANGE_CUSTOMER_ORDER_ITEM_STATUS = gql`
  mutation changeCustomerOrderItemStatus($uuid: String, $status: CustomerOrderItemStatus!) {
    changeCustomerOrderItemStatus(uuid: $uuid, status: $status) {
      success
      assignedSlot
    }
  }
`;

type Props = {
  items: any[];
  tabIndex: number;
  props: any;
  onLimit: any;
  onOffset: any;
};

const HeaderTableData = [
  {
    label: "Image",
    className: "text-left",
  },
  {
    label: "Supplier Code",
    className: "text-left",
  },
  {
    label: "Item",
    className: "text-left",
  },
  {
    label: "Price",
    className: "text-left",
  },
  {
    label: "Net Sale",
    className: "text-left",
  },
  {
    label: "Ref#",
    className: "text-left",
  },
  {
    label: "Package",
    className: "text-left",
  },
  {
    label: "Action",
    className: "text-center",
  },
];

interface RowOrderProp {
  label: string;
  item: any;
  menuItems: MenuProps[];
  show: any;
  setShow: any;
  changeCustomerOrderItemStatus: any;
  refPrint: any;
}

export function OrderField(props: Props) {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const localStorageDisplay = localStorage.getItem(window.location.pathname);
  const [select, setSelect] = useState(
    localStorageDisplay
      ? JSON.parse(localStorageDisplay)
      : HeaderTableData.map((x) => {
          return {
            label: x.label,
            value: x.label,
          };
        }),
  );

  const headers = select.map((x: any) => {
    const res = HeaderTableData.find((f) => f.label === x.label);
    return {
      label: x.label,
      className: res!.className,
    };
  });

  // localStorage.setItem(window.location.pathname, JSON.stringify(select));

  return (
    <table className="table table-striped table-lightfont dataTable">
      {props.props.location && (
        <HeaderTable
          {...props.props}
          offset={offset}
          setOffset={(val: any) => {
            setOffset(val);
            props.onOffset(val);
          }}
          limit={limit}
          setLimit={(val: any) => {
            setLimit(val);
            props.onLimit(val);
          }}
          totalPage={0}
          sort={"x"}
          sortDirection={"ASC"}
          items={headers}
          select={select}
          setSelect={setSelect}
          options={HeaderTableData.map((x) => {
            return {
              label: x.label,
              value: x.label,
            };
          })}
          handleSort={() => {}}
        />
      )}
      <tfoot>
        <tr>
          <th colSpan={9}>
            {props.props.location && (
              <Pagination
                props={props.props}
                offset={offset}
                setOffset={setOffset}
                total={0}
                limit={limit}
                setLimit={setLimit}
              />
            )}
          </th>
        </tr>
      </tfoot>
      <tbody>
        {props.items.map((x: any, i: number) => {
          return <RenderRow item={x} index={i} tabIndex={props.tabIndex} key={i} offset={offset} select={select} />;
        })}
      </tbody>
    </table>
  );
}

function RenderRow({
  item,
  index,
  tabIndex,
  select,
  offset,
}: {
  item: any;
  index: number;
  tabIndex: number;
  offset: number;
  select: any[];
}) {
  let refPrint: HTMLButtonElement | null;
  let refPrint4x3: HTMLButtonElement | null;

  const [changeCustomerOrderItemStatus] = useMutation(CHANGE_CUSTOMER_ORDER_ITEM_STATUS, {
    refetchQueries: ["merchantOrderListBeta"],
    onCompleted: (res: any) => {
      if (res.changeCustomerOrderItemStatus.success) {
        Toast.onShow("Process action was complete.", "success", "right");
      } else {
        Toast.onShow("Process action was fail.", "danger", "right");
      }
    },
  });
  const [show, setShow] = useState(false);

  const menuItems: MenuProps[] = [
    {
      label: "Prepared",
      actived: tabIndex === 0 ? true : false,
      onClick: () => {
        changeCustomerOrderItemStatus({
          variables: {
            uuid: String(item.uuid),
            status: "PREPARED",
          },
        });
      },
    },
    {
      label: "Print",
      actived: true,
      onClick: () => {
        refPrint!.click();
      },
    },
    {
      label: "Print (4x3)",
      actived: true,
      onClick: () => {
        refPrint4x3!.click();
      },
    },
    {
      label: "OOS",
      actived: tabIndex === 0 ? true : false,
      onClick: () => {
        changeCustomerOrderItemStatus({
          variables: {
            uuid: String(item.uuid),
            status: "OOS",
          },
        });
      },
    },
    {
      label: "Discountined",
      actived: tabIndex === 0 ? true : false,
      onClick: () => {
        changeCustomerOrderItemStatus({
          variables: {
            uuid: String(item.uuid),
            status: "DISCONTINUED",
          },
        });
      },
    },
    {
      label: "Pickup Request",
      actived: tabIndex === 1 ? true : false,
      onClick: async () => {
        const res = await confirmService.show({
          message: `
          <h5>Order Pickup Rules​</h5>
          <ul style="padding: 17px">
            <li>Pickup staff visits the store and calls within 3 hours after the request.​</li>
            <li>Pickup staff cancels the request if the store is not open and the number can’t be contacted.​</li>
            <li>Pickup staff cancels the request if the store has not prepared or prepared the wrong item.​</li>
            <li>Pickup staff cancels the request if the price is not the same as in the app.​</li>
            <li>Pickup staff cancels the request if the product’s expiry date is close or the product is damaged.​</li>
          </ul>
          `,
        });

        if (res === true) {
          changeCustomerOrderItemStatus({
            variables: {
              uuid: String(item.uuid),
              status: "REQUEST_PICKUP",
            },
          });
        }
      },
    },
    {
      label: "Shipment",
      actived: tabIndex === 1 ? true : false,
      onClick: () => {
        setShow(true);
        // changeCustomerOrderItemStatus({
        //   variables: {
        //     uuid: String(item.uuid),
        //     status: "MERCHANT_SHIPPED",
        //   },
        // });
      },
    },
  ];

  return (
    <tr key={index}>
      <td>{(index + 1) * (offset + 1)}</td>
      {select.map((x) => {
        switch (x.label) {
          case "Image":
            return (
              <td style={{ width: 150 }}>
                <img
                  src={item.picture || ""}
                  className="cell-img"
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    maxWidth: 105,
                    maxHeight: 140,
                    borderRadius: "5px 5px 0 0",
                    objectFit: "cover",
                  }}
                />
                <br />
                <OrderStatus status={item.status} />
              </td>
            );
          case "Supplier Code":
            return (
              <td style={{ width: 150 }}>
                <span>{item.supplierCode}</span>
                <br />
                <small>L192: {item.code}</small>
              </td>
            );
          case "Item":
            return (
              <td>
                <span>{TestJson(item.title || "") ? JSON.parse(item.title || "").en : item.title}</span>
                <br />
                <small>Size: {item.size}</small>
                <br />
                <small>Color: {item.color}</small>
              </td>
            );
          case "Price":
            return (
              <td className="text-success">
                <span>${item.fullPrice}</span>
              </td>
            );
          case "Net Sale":
            return (
              <td className="text-success">
                <span>${item.prepaidAmount}</span>
              </td>
            );
          case "Ref#":
            return (
              <td>
                <span>{item.uuid}</span>
                <br />
                <span>{(item.log as Graph.OrderItemLog[])[0].date}</span>
              </td>
            );
          case "Package":
            return (
              <td style={{ width: 450 }}>
                {item.package && (
                  <a
                    target={item.package.uuid ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    href={item.package.uuid ? "https://p.l192.com/p/" + item.package.uuid : "#"}
                  >
                    {item.package.id}
                  </a>
                )}
                <br />
                {(item.log as Graph.OrderItemLog[]).map((y: any, j: number) => {
                  return (
                    <small key={j}>
                      {y.description} on {y.date}{" "}
                      {y.description === "Departed from original country" &&
                        `[ ${(item.trackingNumber as string[])[(item.trackingNumber as string[]).length - 1]} ]`}{" "}
                      <br />
                    </small>
                  );
                })}
              </td>
            );
          case "Action":
            return (
              <td style={{ width: 150 }} className="text-center">
                <MenuComponent
                  items={menuItems}
                  menuButton={
                    <Link to="#" style={{ textDecoration: "none" }}>
                      <i className="os-icon os-icon-more-vertical" style={{ fontSize: "15pt" }}></i>
                    </Link>
                  }
                />
                <PrintItem
                  coid={item.uuid}
                  itemid={item.itemID}
                  color={item.color}
                  size={item.size}
                  customer={item.customerID}
                  orderid={item.orderID}
                  fourxthree={false}
                  title="Print"
                  refButton={(e) => (refPrint = e)}
                />
                <ModalConfirm
                  show={show}
                  text={`Did you want shipment item #${item.uuid}?`}
                  handleNo={() => setShow(false)}
                  handleYes={() => {
                    setShow(false);
                    changeCustomerOrderItemStatus({
                      variables: {
                        uuid: String(item.uuid),
                        status: "MERCHANT_SHIPPED",
                      },
                    });
                  }}
                />
              </td>
            );
          default:
            return <></>;
        }
      })}

      <td className="text-center" style={{ width: "4cm", height: "3cm", display: "none" }}>
        <Printe4x3
          data={{
            value: item.uuid,
            color: item.color,
            size: item.size,
            code: item.code,
          }}
          refButton={(ref) => (refPrint4x3 = ref)}
        />
      </td>
    </tr>
  );
}

function ModalConfirm({
  show,
  text,
  handleNo,
  handleYes,
}: {
  show: boolean;
  text: string;
  handleNo: () => void;
  handleYes: () => void;
}) {
  return (
    <Modal show={show} centered onHide={handleNo}>
      <Modal.Body>{text}</Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary btn-sm" onClick={handleYes}>
          Yes
        </button>
        <button className="btn btn-danger btn-sm" onClick={handleNo}>
          No
        </button>
      </Modal.Footer>
    </Modal>
  );
}

function Printe4x3({ data, refButton }: { data: any; refButton: (e: any) => void }) {
  const ref = useRef<HTMLDivElement>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [doc, setDoc] = useState("");

  const onPrintClicked = () => {
    if (ref.current && iframeRef.current) {
      setDoc(
        `<style>html, body { margin: 0; padding: 0; text-align: center;} .center { text-align: center; display: flex, justify-content: center; flex-direction: column; }</style><div class="center">` +
          ref.current.innerHTML +
          "</div><script>window.print(); /*" +
          Math.random().toString() +
          "*/</script>",
      );
    }
  };

  return (
    <div>
      <div ref={ref}>
        <Barcode value={data.value} width={1} height={60} fontSize={10} />
      </div>
      <div>
        <button onClick={onPrintClicked} ref={refButton}>
          Print
        </button>
      </div>
      <iframe
        style={{
          position: "fixed",
          width: 1,
          height: 1,
          left: -1000,
          top: -1000,
        }}
        srcDoc={doc}
        ref={iframeRef}
        title="myframe"
      ></iframe>
    </div>
  );
}
